import { render, staticRenderFns } from "./domains-list-panel.vue?vue&type=template&id=18e0e31a&"
import script from "./domains-list-panel.ts?vue&type=script&lang=ts&"
export * from "./domains-list-panel.ts?vue&type=script&lang=ts&"
import style0 from "./domains-list-panel.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports